<template>
    <div class="trend-search-item-wrap">
        <div v-if="readOnlyStatus" class="trend-search-item-mask" />
        <div>
            <el-select style="width: 100%" v-model="clause.fieldModelId" placeholder="请选择字段" clearable filterable @change="fieldChange">
                <el-option v-for="(field, fieldModelId) in fields" :key="fieldModelId" :label="field.fieldName" :value="field.fieldModelId" />
            </el-select>
        </div>
        <div>
            <!--            数字-->
            <el-select v-if="clause.fieldInputType == 2" v-model="clause.fieldCondKey" placeholder="请选择计算" clearable filterable>
                <el-option v-for="(value, key) in connection.number" :key="key" :label="key" :value="value" />
            </el-select>
            <!--            文本域-->
            <el-select v-else-if="clause.fieldInputType == 5" v-model="clause.fieldCondKey" placeholder="请选择计算" clearable filterable>
                <el-option v-for="(value, key) in connection.textarea" :key="key" :label="key" :value="value" />
            </el-select>
            <!--            选择框-->
            <el-select v-else-if="[6, 7, 8, 9, 12].includes(clause.fieldInputType)" v-model="clause.fieldCondKey" placeholder="请选择计算" clearable filterable>
                <el-option v-for="(value, key) in connection.select" :key="key" :label="key" :value="value" />
            </el-select>
            <!--            日期-->
            <el-select v-else-if="[3, 4, 14, 15].includes(clause.fieldInputType)" v-model="clause.fieldCondKey" placeholder="请选择计算" clearable filterable>
                <el-option v-for="(value, key) in connection.date" :key="key" :label="key" :value="value" />
            </el-select>
            <!--            手机号-->
            <el-select v-else-if="clause.fieldInputType == 1 && clause.fieldDicKeyInputFormat == 2" v-model="clause.fieldCondKey" placeholder="请选择计算" clearable filterable>
                <el-option v-for="(value, key) in connection.phone" :key="key" :label="key" :value="value" />
            </el-select>
            <!--            身份证号-->
            <el-select v-else-if="clause.fieldInputType == 1 && clause.fieldDicKeyInputFormat == 3" v-model="clause.fieldCondKey" placeholder="请选择计算" clearable filterable>
                <el-option v-for="(value, key) in connection.cardCode" :key="key" :label="key" :value="value" />
            </el-select>
            <!--            文本输入框-->
            <el-select v-else v-model="clause.fieldCondKey" placeholder="请选择计算" clearable filterable>
                <el-option v-for="(value, key) in connection.text" :key="key" :label="key" :value="value" />
            </el-select>
        </div>
        <div>
            <!--            数字-->
            <j-input v-if="clause.fieldInputType == 2" type="number" v-model="clause.fieldValue" placeholder="请输入值" @input="sqlHandle" />

            <!--            选择框-->
            <j-dictionary type="select" v-else-if="[6, 7, 8, 9].includes(clause.fieldInputType)" v-model="clause.fieldValue" :code="clause.fieldDicKey" :api="`/api/dictionaryItems/${clause.fieldDicKey}/negot-items`" placeholder="请选择值" @change="sqlHandle" />

            <!--            年月日-->
            <el-date-picker style="width: 100%;" v-else-if="[3, 4, 14, 15].includes(clause.fieldInputType)" v-model="clause.fieldValue" type="date" placeholder="选择日期值" value-format="yyyy-MM-dd" @change="sqlHandle" />

            <!--            所属区域-->
            <j-grid-ctrl style="width: 100%;" v-else-if="clause.fieldInputType == 12" v-model="clause.fieldValue" type="select" placeholder="选择行政区划" />

            <!--            时分秒-->
            <!--            <el-date-picker style="width: 100%;" v-else-if="[3, 4, 14, 15].includes(clause.fieldInputType)" v-model="clause.fieldValue" type="date" placeholder="选择日期值" value-format="yyyy-MM-dd HH:mm:ss" @change="sqlHandle" />-->

            <!--            普通文本和文本域-->
            <!--            <j-input v-else-if="[1, 2, 3, 5].includes(clause.fieldInputType)" v-model="clause.fieldValue" placeholder="请输入值" @input="sqlHandle" />-->
            <j-input v-else v-model="clause.fieldValue" placeholder="请输入值" @input="sqlHandle" />
        </div>
        <div v-if="!readOnlyStatus" class="trend-search-item-ctrl">
            <slot />
        </div>
    </div>
</template>

<script>
    import JInput from "../../../JComponents/JInput/JInput";
    import JGridCtrl from "../../../JComponents/JGridCtrl/JGridCtrl";
    import JDictionary from "../../../JComponents/JDictionary/JDictionary";
    export default {
        name: "TrendSearchItem",
        inject:['fieldMap', 'readOnly'],
        components: {
            JDictionary,
            JInput,
            JGridCtrl
        },
        props: {
            clause: {
                type: Object
            }
        },
        data() {
            return {
                connection: {
                    text: { '等于': '=', '包含': 'like', '不等于': '!=' },
                    number: { '等于': '=', '大于等于': '>=', '大于': '>', '小于等于': '<=', '小于': '<' },
                    phone: { '等于': '=' },
                    cardCode: { '等于': '=' },
                    date: { '等于': '=', '大于等于': '>=', '大于': '>', '小于等于': '<=', '小于': '<' },
                    select:  { '等于': '=' },
                    textarea: { '包含': 'like' }
                }
            }
        },
        computed: {
            fields () {
                return this.fieldMap()
            },
            readOnlyStatus () {
                return this.readOnly()
            }
        },
        methods: {
            fieldChange (fieldId) {
                this.clause.fieldCondKey = ''
                this.clause.fieldValue = ''
                const field = this.fields[fieldId]
                this.clause.fieldDicKey = field.fieldDicKey
                this.clause.fieldDicKeyInputFormat = field.fieldDicKeyInputFormat
                this.clause.fieldInputType = field.fieldInputType
                this.clause.fieldName = field.fieldName
                this.clause.queryField = field.fieldEng
                this.clause.fieldGroup = field.fieldGroup
                // this.sqlHandle()
                // queryGroup: "",
            },
            sqlHandle () {
                // if (this.clause.fieldCondKey === 'like') {
                //     this.clause.querySql = `${this.clause.queryField} ${this.clause.fieldCondKey} '%${this.clause.fieldValue}%'`
                //     return
                // }
                // this.clause.querySql = `${this.clause.queryField} ${this.clause.fieldCondKey} '${this.clause.fieldValue}'`
            }
        }
    }
</script>

<style lang="scss">
    .trend-search-item-wrap {
        position: relative;
        display: flex;
        justify-content: space-around;
        margin-top: 12px;
        > div {
            width: 30%;
            padding-right: 16px;
        }
        .trend-search-item-ctrl {
            width: 10%;
            height: 32px;
            display: flex;
            align-items: center;
            padding-right: 0;
        }
        .trend-search-item-mask {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: transparent;
            z-index: 1;
        }
    }
</style>
